document.addEventListener('DOMContentLoaded', () => {
  const cartElement = document.getElementById('cart');
  const submitButton = document.querySelector('button#checkout');
  if (!cartElement) {
    return;
  }
  cartElement.addEventListener('submit', function (event) {
    const formData = new FormData(this);

    console.log(Object.fromEntries(formData));
    event.preventDefault();
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner')
            .classList.remove('hidden');

    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const cartToken = data.token;
        fetch(window.Shopify.routes.root + 'apps/bc/cart-to-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
            cartToken: cartToken,
            attributes: {
              customerOrderNo: formData.get("attributes[customerOrderNo]"),
              reference: formData.get("attributes[reference]"),
              projectId: formData.get("attributes[projectId]"),
              shippingDate: formData.get("attributes[shippingDate]")
            }
          })
        })
          .then((response) => response.json())
          .then((checkoutResponse) => {
            if (checkoutResponse.checkoutUrl) {
              // Persist a marker for the cart that is being checked out so the
              // reconciler script can clear the cart only after the order has
              // actually been placed in Shopify (see pistesarjat-checkout-reconcile.js).
              try {
                localStorage.setItem(
                  'pistesarjat:pendingCheckout',
                  JSON.stringify({
                    cartToken: cartToken,
                    checkoutUrl: checkoutResponse.checkoutUrl,
                    ts: Date.now(),
                  })
                );
              } catch (e) {
                console.error('Failed to persist pendingCheckout', e);
              }
              // Do NOT clear the cart here. If the customer abandons the
              // Shopify checkout, the cart must remain intact.
              window.location = checkoutResponse.checkoutUrl;
            }
          })
          .catch((error) => console.error(error))
          .finally(() => {
            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('loading');
            submitButton.querySelector('.loading-overlay__spinner')
                    .classList.add('hidden');
          });
      });
  });
});
